/* CardCover.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJiObl%7Bgrid-area%3Acover%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._0pI6nMDIqT%7Bjustify-items%3Acenter%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._3iDTPbgBM8%7Bdisplay%3Agrid%7D%0A._42d1HA5zaO%7Brow-gap%3Avar(--ds-space-200%2C1pc)%7D%0A._0xmtkoNHnM%7Bpadding-block-end%3Avar(--ds-space-300%2C24px)%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._2I62gzUgYP%7Binset-block-start%3Avar(--ds-space-negative-200%2C-1pc)%7D%0A._1ZB6UyPgdg%7Binset-block-end%3Avar(--ds-space-0%2C0)%7D%0A._3iC0zdUgYP%7Binset-inline-start%3Avar(--ds-space-negative-200%2C-1pc)%7D%0A._1OKFqYUgYP%7Binset-inline-end%3Avar(--ds-space-negative-200%2C-1pc)%7D%0A._1pp6NdYbGa%7Bpointer-events%3Anone%7D%0A._0KLXrunmFW%7Bbackground-color%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D%0A._3X9j4qp3mJ%7B-webkit-mask-image%3Alinear-gradient(180deg%2C%23000%2Ctransparent)%3Bmask-image%3Alinear-gradient(180deg%2C%23000%2Ctransparent)%7D%0A._0bjKvDS5Zs%7Bborder-radius%3Avar(--ds-radius-full%2C9999px)%7D%0A._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._3hxITi6wH8%7Bborder-style%3Asolid%7D%0A._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._43nrzTB0rP%7Bmargin-block-start%3Avar(--ds-space-negative-150%2C-9pt)%7D%0A._39xV02UF4f%7Bwidth%3A40px%7D%0A._0jFU0VJg58%7Bheight%3A8px%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._2I62gzPgdg%7Binset-block-start%3Avar(--ds-space-0%2C0)%7D%0A._1OKFqYPgdg%7Binset-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._42Yu6Bbhqd%7Bz-index%3A200%7D%0A._0pI6nMF05b%7Bjustify-items%3Aend%7D%0A._1EqgXlN91d%7Bmax-width%3A100%25%7D%0A._1xC2CJYhv7%7Bgrid-area%3A1%2F1%7D");





























import React from 'react';
import Avatar from '@atlaskit/avatar/avatar';
import { cx } from '@atlaskit/css';
import Image from '@atlaskit/image/image';
import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { Box } from '@atlaskit/primitives/compiled/box';
import { CardAvatarFrame } from './CardAvatarFrame';
import { CardCover as LegacyCardCover } from './Legacy/CardCover';
export type CardCoverStyle = NonNullable<CardCoverProps['coverStyle']>;
export type CardCoverProps = React.ComponentProps<typeof LegacyCardCover> & {
  background?: React.ReactNode;
};
import { CardCoverArtwork } from './CardCoverArtwork';
const styles = {
  cover: "_1xC2CJiObl _0hPCNLDIqT _0pI6nMDIqT _1mT5xdRAKS _3iDTPbgBM8 _42d1HA5zaO _0xmtkoNHnM",
  background: "_1mT5xdWVPG _2I62gzUgYP _1ZB6UyPgdg _3iC0zdUgYP _1OKFqYUgYP _1pp6NdYbGa",
  neutral: "_0KLXrunmFW",
  gradient: "_3X9j4qp3mJ",
  cutout: "_0bjKvDS5Zs _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1mT5xdRAKS _24h04i2Njc _43nrzTB0rP _39xV02UF4f _0jFU0VJg58",
  avatar: "_1mT5xdRAKS _3iDTPbQ4SZ",
  trailing: "_1mT5xdWVPG _2I62gzPgdg _1OKFqYPgdg _42Yu6Bbhqd _3iDTPbgBM8 _0pI6nMF05b _0hPCNLDIqT _1EqgXlN91d",
  layer: "_1xC2CJYhv7"
};
const DefaultAvatar = ({
  name,
  iconUrl
}: {
  name: string;
  iconUrl?: string;
}): React.JSX.Element => iconUrl ? <Image src={iconUrl} alt={name} width={48} height={48} /> : <CardAvatarFrame>
			<Avatar name={name} size="xlarge" />
		</CardAvatarFrame>;
export const CardCover = (props: CardCoverProps): React.JSX.Element => {
  if (!expVal('jira_browse_agent_modal_update', 'isEnabled', false)) {
    return <LegacyCardCover {...props} />;
  }
  const {
    name,
    avatar: AvatarComponent = DefaultAvatar,
    coverStyle = 'grid',
    coverColor,
    background,
    children,
    badge,
    iconUrl,
    testId
  } = props;
  return <Box xcss={styles.cover} testId={testId}>
			{background !== undefined ? <Box xcss={styles.background} aria-hidden="true">
					{background}
				</Box> : coverStyle !== 'gradient' ? <Box xcss={cx(styles.background, styles.neutral)} aria-hidden="true">
					{coverStyle === 'grid' ? <CardCoverArtwork /> : null}
				</Box> : <Box xcss={cx(styles.background, styles.gradient)} style={{
      backgroundColor: coverColor
    }} aria-hidden="true" />}
			<Box xcss={styles.cutout} data-card-cutout aria-hidden="true" />
			<Box xcss={styles.avatar}>
				<AvatarComponent name={name} iconUrl={iconUrl} />
			</Box>
			{badge || children ? <Box xcss={styles.trailing}>
					{badge ? <Box xcss={styles.layer}>{badge}</Box> : null}
					{children ? <Box xcss={styles.layer}>{children}</Box> : null}
				</Box> : null}
		</Box>;
};